import Vue from 'vue';
import querystring from 'querystring';
import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
import * as Articulos from '@lib/Articulos';
import { Publicacion } from '@lib/MercadoLibre/Publicaciones';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';


export class ControladorSeccion
{

    public readonly Buscador: Buscador = new Buscador();

    Iniciar()
    {
        this.Buscador.Iniciar();
    }

    protected coeficiente: number = null;
    public get Coeficiente(): number
    {
        return this.coeficiente;
    }

    public set Coeficiente( x: number )
    {
        if ( this.coeficiente != x )
        {
            if ( x > 100  || x < -90 )
            {
                this.Coeficiente = 0;
                return;
            }

            this.coeficiente = x;
            this._onRecargar.dispatch();
        }

    }

    public Vista: Vista = new Vista();
    private _onRecargar= new SignalDispatcher();
    public get onRecargar() { return this._onRecargar.asEvent(); }

    Ejecutar()
    {
        this._onEjecutar.dispatch();
    }
    private _onEjecutar = new SignalDispatcher();
    public get onEjecutar() { return this._onEjecutar.asEvent(); }
}

export class Vista
{
    public Filtros: FiltrosBase = new FiltrosBase();

    protected modo: string = 'resumen';
    get Modo(): string { return this.modo; }
    set Modo( m: string ) { this.modo = m; this._onModo.dispatch(); }
    private _onModo = new SignalDispatcher();
    public get onModo() { return this._onModo.asEvent(); }
}

type Estado = 'cargando' | 'vacio' | 'ok' | 'error';
export class Buscador
{

    public Parametros = {
        q: '',
        incremental: 'S',
        cuenta: '',
        tipo_articulo: '',
        tipo: '',
        estado: '',
        page: 1,
        limit: 13,
    }

    public Items: Publicacion[] = [];
    public Total: number = 0;

    Iniciar()
    {

    }

    protected estado: Estado = 'cargando';
    get Estado(): Estado { return this.estado; }
    set Estado( m: Estado ) { this.estado = m; this._onEstado.dispatch(); }
    private _onEstado = new SignalDispatcher();
    public get onEstado() { return this._onEstado.asEvent(); }

    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    public Paginacion: Paginacion;

    public async Buscar( pagina: number = null )
    {
        if ( pagina )
            this.Parametros.page = pagina;

        this.Items.clear();
        this.Estado = 'cargando';
        this._onActualizar.dispatch();

        await Wait( 100 );
        let e = await Publicacion.find( this.Parametros );
        if ( e.Error )
            this.Estado = 'error';
        else
        {
            this.Items = e.Items;
            this.Paginacion = e.Paginacion;
            this.Total = e.Paginacion.Total;
            if ( this.Items.hasRows() )
                this.Estado = 'ok';
            else
                this.Estado = 'vacio';
        }

        this._onActualizar.dispatch();
    }
}

const Controlador = new ControladorSeccion();
export { Controlador };

